<div class="dashboard-intervention-form">
  <div class="dashboard-intervention-form__title" *ngIf="isEdit">
    {{ selectedIntervention?.name }} &nbsp; {{ selectedIntervention?.code }}
  </div>
  <form
    class="dashboard-intervention-form__form"
    [formGroup]="interventionForm"
    dashboardConnectForm
    [connectForm]="isEdit ? selectedIntervention : null"
    fxLayout="column"
    fxLayoutGap="30px"
    fxLayoutAlign="center"
  >
    <mat-form-field fxFill>
      <input matInput formControlName="name" placeholder="Title" />
      <mat-error *ngIf="name.hasError('required')"> Intervention page title is <strong>required</strong></mat-error>
      <mat-error *ngIf="name.hasError('minlength')">
        Intervention page title must be at least
        <strong>{{ name.errors?.requiredLength }} characters</strong> long
      </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="selectedStudy?.type === StudyType.CC" fxFill>
      <mat-label>Unique URL Slug : {{ careerUrl + '/' + interventionForm.value.hash }}</mat-label>
      <input matInput formControlName="hash" />
      <mat-error *ngIf="hash.hasError('required')"> Intervention page hash is <strong>required</strong></mat-error>
      <mat-error *ngIf="hash.hasError('maxlength')">
        Intervention page hash must not exceed
        <strong>{{ hash.errors?.maxlength.requiredLength }} characters</strong>
      </mat-error>
      <mat-error *ngIf="hash.hasError('cannotContainSpace')">
        Intervention page hash must not contain <strong>whitespace</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field fxFill>
      <input matInput formControlName="description" placeholder="Description" />
      <mat-error *ngIf="description.hasError('required')">
        Intervention page description is <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <dashboard-image-upload
      *ngIf="selectedStudy?.type === StudyType.TIIM"
      formControlName="imagePath"
      [uuid]="imageUploadUuid"
      [label]="'Image'"
      [isEdit]="isEdit"
      [isImageToEdit]="isImageToEdit"
      [imgPath]="imgPath"
      [keyForUpload]="keyForUpload"
      [idsForUpload]="idsForUpload"
    >
    </dashboard-image-upload>
    <div *ngIf="selectedStudy?.type === StudyType.CC" fxLayoutGap="10px">
      <div class="dashboard-intervention-form__form-label">Send Career Compass report after</div>
      <div
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between center"
        formArrayName="sendReportAfterArray"
      >
        <div *ngFor="let sendReportAfterUnit of sendReportAfterArray.controls; index as i" fxFlex="20">
          <mat-form-field fxFill>
            <input
              matInput
              type="number"
              placeholder="{{ TIMER_ARRAY_UNITS[i] }}"
              [formControlName]="i"
              [min]="0"
              oninput="validity.valid || (value=0);"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <mat-checkbox *ngIf="selectedStudy?.type === StudyType.TIIM" formControlName="isDefault">
      Set as default
    </mat-checkbox>
  </form>
  <div fxLayout="column" fxLayoutAlign="space-around end" fxFill>
    <button
      mat-raised-button
      color="accent"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
      (click)="saveIntervention()"
    >
      {{ 'Save Intervention' | uppercase }}
    </button>
  </div>
</div>
